import {rfidConstants} from "../constants/rfid.constants";
import {rfidService} from "../services/rfid.service";

const getDropdownListRfIf = () => {
    return dispatch => {
        dispatch({type: rfidConstants.REQUEST_DROPDOWN_LIST})
        rfidService.getDropdownList()
            .then(
                (dropdown) => {
                    dispatch({type: rfidConstants.SUCCESS_DROPDOWN_LIST, dropdown})
                },
                (error) => {
                    console.log(error)
                }
            )
    }
}

const getUnusedTags = () => {
    return dispatch => {
        dispatch({type: rfidConstants.REQUEST_UNUSED_LIST})
        rfidService.getUnusedTags()
            .then(
                (unused) => {
                    dispatch({type: rfidConstants.SUCCESS_UNUSED_LIST, unused})
                },
                (error) => {
                    console.log(error)
                }
            )
    }
}

export const rfidActions = {
    getDropdownListRfIf,
    getUnusedTags
}